import { Message, Segment, colorWithOpacity, spacingFn } from '@britishcouncil/react-extro-ui';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import nppTheme from '../styles/nppTheme';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacing.sm};
`;

export const PaymentMethodLogo = styled(Segment)`
  img {
    max-height: ${spacingFn(5.25)};
    max-width: ${spacingFn(12.5)};
    height: ${spacingFn(5.25)};
  }

  box-shadow: none;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.indigo};
`;

export const InternalPaymentMethodLogo = styled(PaymentMethodLogo)`
  img {
    max-height: ${spacingFn(4.5)};
    max-width: ${spacingFn(4.5)};
    height: ${spacingFn(4.5)};
  }
`;

export const PaymentMethodSegment = styled(Segment)<{
  disabled: boolean;
  textLength?: number;
  badgeRoom?: boolean;
}>`
  position: relative;
  /* Clip children to the card's own border-radius so the corner ribbon's
     bottom-left is cut to follow the rounded corner exactly (radius-agnostic). */
  overflow: hidden;
  align-items: center;
  justify-content: center;
  padding: 5px;
  height: ${({ textLength = 0, badgeRoom = false }) => {
    if (badgeRoom) {
      if (textLength <= 26) return spacingFn(14);
      if (textLength <= 37) return spacingFn(16);
      return spacingFn(18);
    }
    if (textLength <= 26) return spacingFn(10);
    if (textLength <= 37) return spacingFn(12);
    return spacingFn(14);
  }};

  @media screen and (max-width: 430px) {
    height: ${({ textLength = 0, badgeRoom = false }) => {
      if (badgeRoom) {
        if (textLength <= 26) return spacingFn(16);
        if (textLength <= 37) return spacingFn(18);
        return spacingFn(20);
      }
      if (textLength <= 26) return spacingFn(12);
      if (textLength <= 37) return spacingFn(14);
      return spacingFn(16);
    }};

    div {
      font-size: 13px;
    }
  }

  ${({ disabled }) => {
    if (disabled) {
      return css`
        cursor: not-allowed;
        opacity: 0.3;
      `;
    }
  }};

  ${({ selected }) => {
    if (selected) {
      return css`
        cursor: default;
      `;
    }
  }};

  :focus {
    border: 2px solid ${colorWithOpacity('darkBlue', 0.5)};
  }
`;

export const MethodBadge = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 2;
  pointer-events: none;
  white-space: nowrap;
  background: #ffc72c;
  color: ${({ theme }) => theme.colors.indigo};
  font-family: ${nppTheme.typography.bcSans};
  font-weight: 700;
  font-size: 13px;
  line-height: 1.3;
  letter-spacing: 0.2px;
  padding: 4px 14px;
  /* Only the top-right tab is rounded; the bottom-left is squared here and the
     parent's overflow:hidden clips it to the card's rounded corner. */
  border-radius: 0 8px 0 0;

  @media screen and (max-width: 430px) {
    font-size: 12px;
    padding: 3px 10px;
  }
`;

export const InternalPaymentMethodText = styled.div`
  font-family: ${nppTheme.typography.bcSans};
  color: ${({ theme }) => theme.colors.indigo};
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSize.desktop.small};
  gap: 1px;
  text-align: center;
  width: 100%;
`;

export const InternalPaymentMethodWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacingFn(0.5)};
`;

export const PaymentMethodList = styled.div`
  > [class^='col'] {
    padding: 0 ${({ theme }) => theme.spacing.sm};
    margin-top: ${({ theme }) => theme.spacing.lg};

    @media screen and (max-width: 376px) {
      padding: 0 ${({ theme }) => theme.spacing.xs};
    }
  }
`;

export const PaymentMethodChangerMessage = styled(Message)`
  margin-top: ${spacingFn(6)};
`;
